import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { IThunkRejectValue, RootState } from "./../../../types";
import { getExtractErrors } from "../../../apis";
import { CustomErrorToast } from "../../../components/general/Toast";
import { getAiNotebookApi } from "../../../apis/ai-notebooksAPI";
import { AiNotebook, AiNotebookState } from "../../../types/ai";
// import { dummyNotebooks } from "./notebooksSlice";

const initialState: AiNotebookState = {
  notebook: null,
  notebookLoading: false,
  showSynchronisationModal: false,
};

export const getAiNotebookAsync = createAsyncThunk<
  { notebook: AiNotebook },
  { id: string; withoutLoading?: boolean },
  IThunkRejectValue
>(
  "notebook",
  async (
    { id, withoutLoading = false },
    { rejectWithValue, fulfillWithValue, dispatch, requestId }
  ) => {
    try {
      dispatch(
        getAiNotebookAsync.pending(requestId, {
          id,
          withoutLoading,
        })
      );
      const response = await getAiNotebookApi(id);
      const notebook = response.data.Result;
      return fulfillWithValue({ notebook });
    } catch (e) {
      return rejectWithValue({ message: getExtractErrors(e) });
    }
  }
);

export const aiNotebookSlice = createSlice({
  name: "notebook",
  initialState,
  reducers: {
    handleClearAiNotebookSlice: (state) => {
      state.notebook = initialState.notebook;
      state.notebookLoading = initialState.notebookLoading;
    },

    handleSynchronisation: (
      state,
      { payload: { status } }: PayloadAction<{ status: boolean }>
    ) => {
      state.showSynchronisationModal = status;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAiNotebookAsync.pending, (state, action) => {
        if (!action.meta.arg.withoutLoading) state.notebookLoading = true;
      })
      .addCase(getAiNotebookAsync.fulfilled, (state, action) => {
        const { notebook } = action.payload;
        state.notebook = notebook;
        state.notebookLoading = false;
      })
      .addCase(getAiNotebookAsync.rejected, (state, { payload }) => {
        state.notebookLoading = false;
        // state.notebook = dummyNotebooks[2]; //TODO
        if (payload?.message)
          toast.error(() => CustomErrorToast(payload?.message));
      });
  },
});

export const selectAiNotebook = (state: RootState) => state.aiNotebook.notebook;
export const selectAiNotebookLoading = (state: RootState) =>
  state.aiNotebook.notebookLoading;

export const selectShowSynchronisationModal = (state: RootState) =>
  state.aiNotebook.showSynchronisationModal;

export const { handleClearAiNotebookSlice, handleSynchronisation } =
  aiNotebookSlice.actions;
export default aiNotebookSlice.reducer;
